import { RootState } from '@glass/web/modules/redux/types';
import { USER_CONFIG_REDUCER_KEY } from '@glass/web/modules/userConfig/deprecatedTypes';

export const AUTH_READY_KEY = 'authReady';

const selectIsAuthReady = (state: RootState) => state[USER_CONFIG_REDUCER_KEY][AUTH_READY_KEY];

export default selectIsAuthReady;
